import get_title from "@/router/module/get_title";
import validate_role from "@/router/module/validate_role";

export default {
  path: "/content/settings/project/:id/edit",
  alias: "/content/settings/project/edit/:id",
  name: "project.edit",
  component: () => import("@/new/pages/settings/project/detail/edit.vue"),
  meta: {
    title: get_title("Редактирование проекта"),
    forVisitors: true,
    requiresAuth: true
  },
  beforeEnter: (to, from, next) => {
    const options = {
      role: "settings_project",
      route: { to, from, next },
      callback: false,
      redirectText: "У вас нет доступа к разделу с настройками!",
    };
    validate_role(options);
  },
};
